<template>
<div>
  <loading v-if="items == null"></loading>

  <div v-else>
    <v-row>
      <v-col sm="6" :key="item.uuid" v-for="item in items">
        <v-card outlined class="expose-inquiry__item">
          <v-img
            height="280"
            :src="item.image"
          ></v-img>

          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="text-h5">{{ item.title }}</v-list-item-title>
              <v-list-item-subtitle>in {{ item.zip }} {{ item.city }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-card-actions>
            <ul class="expose-inquiry__list">
              <li>
                <v-icon color="primary">$vuetify.icons.home</v-icon>
                {{ item.category }}
              </li>

              <li>
                <v-icon color="primary">$vuetify.icons.coins</v-icon>
                <p>
                  {{ item.price.title }}
                  <span v-html="item.price.text"></span>
                </p>
              </li>

              <li>
                <v-btn color="primary" large :href="item.link" target="_blank" block>Exposé</v-btn>
              </li>
            </ul>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</div>
</template>

<script>
import Loading from "./utils/Loading";

export default {
  name: "ExposeInquiryList",

  components: {
    Loading
  },

  data() {
    return {
    }
  },

  computed: {
    items() {
      return this.$store.state.contact.exposeInquiryList;
    }
  },

  created() {
    this.$store.dispatch("contact/loadExposeInquiryList");
  }
};
</script>
